var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath23100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23100",
    "data-name": "Path 23100",
    d: "M132.3,254.687a7.5,7.5,0,1,1-15,0,7.634,7.634,0,0,1,.344-2.258l-7.68-4.8a7.5,7.5,0,1,1,0-10.875l7.68-4.8a7.594,7.594,0,0,1-.344-2.258,7.5,7.5,0,1,1,2.336,5.438l-7.68,4.8a7.546,7.546,0,0,1,0,4.516l7.68,4.8a7.5,7.5,0,0,1,12.664,5.437m-23.75-12.5a3.75,3.75,0,1,0-3.75,3.75,3.751,3.751,0,0,0,3.75-3.75m12.5-12.5a3.75,3.75,0,1,0,3.75-3.75,3.751,3.751,0,0,0-3.75,3.75m7.5,25a3.75,3.75,0,1,0-3.75,3.75,3.751,3.751,0,0,0,3.75-3.75",
    transform: "translate(-97.304 -222.187)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath23100);
export default __webpack_public_path__ + "static/media/Path 23100.efa9276db89d3eecf3f150b24ff6da22.svg";
export { ForwardRef as ReactComponent };